import React, { useEffect, useState } from "react";
import StarProfileRightContent from "../StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import axios from "axios";
import SkeletonArticle from "../.../../../../components/Post_skaliton/SkeletonArticle";
import PostContent from "../.../../../../Screen/Post/PostContent";
import NodataAvailable from "../../Common/NodataAvailable";

const StarQna = ({ star_id }) => {
    const [status, setStatus] = useState(true);
    const [posts, setPosts] = useState([]);
    const [openMessenger, setOpenMessenger] = React.useState(false);
  
    useEffect(() => {
      axios.get(`api/user/getStarPost/${star_id}/qna`).then((res) => {
        if (res.data.status === 200) {
            setPosts(res.data.posts);
            setStatus(false);
        }
      });
    }, []);
  return (
    <div className="container StarContainer">
    <div className="row">
      <div className="col-md-8 TabeStar">
        {status &&
          [1, 2, 3, 4].map((valu) => <SkeletonArticle theme="dark" />)}

        {posts.length > 0 ? (
          posts.map((data) => <PostContent key={data.id} post={data} />)
        ) : (
          <NodataAvailable className="mt-5" />
        )}
        
      </div>

      <div className="col-md-4">
        <StarProfileRightContent
          openMessenger={openMessenger}
          setOpenMessenger={setOpenMessenger}
          star_id={star_id}
        />
      </div>
    </div>
  </div>
  )
}

export default StarQna